<template>
  <div class="awardItem">
    <div class="awardIcon">
      <Award :awardData="awardData" />
    </div>
    <div class="main">
      <div class="titleArea">
        <span class="label">{{ awardData.businessTypeStr }}</span>
        <span class="title">{{ awardData.title }}</span>
      </div>
      <div class="time">{{ timeText }}</div>
      <button class="btn" @click="handleUseCoupon(awardData)">
        去使用
      </button>
    </div>
  </div>
</template>

<script>
import Award from '@/components/templates/common/awardItem/Award';
import { toDayDate } from '../../../helper';
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';

export default {
  components: { Award },
  props: {
    awardData: {
      type: Object,
      required: true
    }
  },
  computed: {
    timeText() {
      if (
        this.awardData &&
        this.awardData.startTime &&
        this.awardData.endTime
      ) {
        return `有效期：${toDayDate(this.awardData.startTime)}-${toDayDate(
          this.awardData.endTime
        )}`;
      }
      return '';
    }
  },
  methods: {
    handleUseCoupon(award) {
      useCoupon(award.businessType);
      this.$emit('reportEvent', {
        event: 'invite_boost_coupon_reward_click',
        module_name: '我的奖励页',
        button_name: '去使用',
        coupon_id: award.rewardCode
      });
    },
    handleUseAward(award) {
      location.href = award.clickUrl;
    },
    handleGoAddressPage() {
      this.$router.push('/contact');
    }
  }
};
</script>

<style lang="less" scoped>
.awardItem {
  margin: 0 auto 24px;
  display: flex;
  padding: 30px 24px;
  background-color: #fff;
  align-items: center;

  .awardIcon {
    flex: 140px 0 0;
    margin-right: 32px;
    height: 140px;
    font-size: 32px;
  }

  .main {
    flex-grow: 1;
    min-height: 140px;
    .titleArea {
      display: flex;
      align-items: center;
      line-height: normal;
      overflow: hidden;

      .label {
        margin-right: 14px;
        padding: 0 10px;
        font-size: 24px;
        color: #ff6600;
        border: 2px solid #ff6600;
        border-radius: 7px;
      }

      .title {
        font-size: 32px;
        color: #262626;
      }
    }

    .time {
      margin-top: 5px;
      height: 38px;
      font-size: 26px;
      color: #8c8c8c;
    }

    .btn {
      margin-top: 15px;
      margin-right: 10px;
      float: right;
      width: 160px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: normal;
      font-size: 26px;
      color: #ffffff;
      background: linear-gradient(to top, #ff0044 0%, #ff4153 38%, #fd515f 99%);
      border-radius: 24px;
    }
  }
}
</style>
